import React, { useEffect, useMemo } from 'react';
import styles from '@dazn/lp-web/src/components/BannerSlider/banner-slider.module.css';
import { IBannerSlider } from '@dazn/lp-web/src/types';
import { useLandingPagesContext } from '@dazn/lp-web/src/contexts/LandingPageContext';
import { getBanners } from '@dazn/lp-web/src/components/BannerSlider/banner-slider.utils';
import DesktopSlider from './DesktopSlider/DesktopSlider';
import { MobileSlider } from './MobileSlider/MobileSlider';
import isQueryParamTrue from '../../utils/isQueryparamTrue';
import { VideoBannerContextProvider } from '@dazn/lp-web/src/components/VideoBanner/VideoBannerContext';
import { shouldSuperImpose } from '../Header/Utils/features';
import { useMedia } from '../../hooks/useMedia';
import classNames from 'classnames';
import { bannerTypes } from '../../constants/bannerTypes.constants';

interface IBannerSliderProps {
    data: IBannerSlider;
    key: number;
    disableAnimation: boolean;
}

const BannerSlider: React.FC<IBannerSliderProps> = ({ data }) => {
    const [activeIndex, setActiveIndex] = React.useState(0);
    const { isMobile } = useMedia();
    const { offers, promoOffers, multiplePromoOffers } = useLandingPagesContext();
    const banners = getBanners({
        data,
        offers,
        promoOffers,
        multiplePromoOffers
    });
    useEffect(() => {
        const element: any = document.querySelector(
            '[data-target=background-overlay]'
        );
        if (element) {
            element.style.display = 'none'; // Force repaint
            element.offsetHeight; // Trigger reflow
            element.style.display = ''; // Reapply display
        }
    }, []);
    const isRotatingBannerExist = useMemo(() => {
        return banners?.find(
            (banner) =>
                banner?.bannerType?.toLowerCase() ===
                bannerTypes.ROTATING_CONTENT.toLowerCase()
        );
    }, [banners]);

    if (!banners?.length) {
        return null;
    }


    return (
        <VideoBannerContextProvider>
            <div className={styles.bannersContainer}>
                <img
                    className={styles.backgroundImage}
                    src={data?.banners[activeIndex]?.backgroundImage?.mobile}
                    alt="background"
                />
                <div
                    className={classNames(styles.backgroundOverlay, {
                        [styles.backgroundOverlayBlurRemove]:
                            isRotatingBannerExist && isMobile
                    })}
                    data-target="background-overlay"
                />
                {isQueryParamTrue('seo') ? (
                    <>
                        <MobileSlider
                            banners={banners}
                            activeIndex={activeIndex}
                            setActiveIndex={setActiveIndex}
                        />
                        <DesktopSlider
                            banners={banners}
                            activeIndex={activeIndex}
                            setActiveIndex={setActiveIndex}
                        />
                    </>
                ) : (isMobile) && !shouldSuperImpose() ? (
                    <MobileSlider
                        banners={banners}
                        activeIndex={activeIndex}
                        setActiveIndex={setActiveIndex}
                    />
                ) : (
                    <DesktopSlider
                        banners={banners}
                        activeIndex={activeIndex}
                        setActiveIndex={setActiveIndex}
                    />
                )}
            </div>
        </VideoBannerContextProvider>
    );
};

export default BannerSlider;
